import { createSlice } from '@reduxjs/toolkit';
import { ReminderDetailStateType } from 'src/types/reminderDetail';

const initialState: ReminderDetailStateType = {
    data: null,
    loading: false,
    canceled: false,
    removedFromAttendees: false,
    error: false,
    saved: false,
};
export const reminderDetailSlice = createSlice({
    name: 'reminderDetail',
    initialState,
    reducers: {
        getReminderDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getReminderDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        getReminderDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        createReminderDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createReminderDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.saved = true;
        },
        createReminderDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateReminderDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateReminderDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.saved = true;
        },
        updateReminderDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        cancelReminderDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        cancelReminderDetailFetchSuccess: (state, action) => {
            state.canceled = true;
            state.data = action.payload.data;
            state.loading = false;
            state.saved = true;
        },
        cancelReminderDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        removeFromReminderAttendeesFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        removeFromReminderAttendeesFetchSuccess: (state, action) => {
            state.removedFromAttendees = true;
            state.data = action.payload.data;
            state.loading = false;
            state.saved = true;
        },
        removeFromReminderAttendeesFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearReminderDetail: () => initialState,
    },
});

export const {
    getReminderDetailFetch,
    getReminderDetailFetchSuccess,
    getReminderDetailFetchFailure,
    createReminderDetailFetch,
    createReminderDetailFetchSuccess,
    createReminderDetailFetchFailure,
    updateReminderDetailFetch,
    updateReminderDetailFetchSuccess,
    updateReminderDetailFetchFailure,
    cancelReminderDetailFetch,
    cancelReminderDetailFetchSuccess,
    cancelReminderDetailFetchFailure,
    removeFromReminderAttendeesFetch,
    removeFromReminderAttendeesFetchSuccess,
    removeFromReminderAttendeesFetchFailure,
    clearReminderDetail,
} = reminderDetailSlice.actions;

export default reminderDetailSlice.reducer;
